module.exports = __webpack_public_path__ + "img/calendar-days.f398ed74.svg";